export const ebookSecondsUserHistoryStateKey = 'RAAS_EBOOK_TIME';
export const ebookSecondsThreshold = 60;
